import React from 'react';
import { Box, Container, Typography, IconButton, Tooltip, useTheme } from '@mui/material';
import { useColorMode } from '@/context/ColorModeContext';

export const TopUtilityBar: React.FC = () => {
  const theme = useTheme();
  const { mode, toggleColorMode } = useColorMode();
  const isDark = mode === 'dark';

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        py: 0.75,
        fontSize: '0.8125rem',
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 4, overflow: 'hidden', whiteSpace: 'nowrap' }}>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
              GST: 29AAHCI5157L1Z0
            </Typography>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontWeight: 500, display: { xs: 'none', md: 'inline' } }}>
              CIN: U41001KA2024PTC184411
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <span
                className="material-symbols-outlined"
                style={{ fontSize: 16, color: theme.palette.primary.main }}
              >
                location_on
              </span>
              <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
                Kundalahalli, Bengaluru
              </Typography>
            </Box>

            {/* Dark / Light Theme Toggle Switch */}
            <Tooltip title={`Switch to ${isDark ? 'Light' : 'Dark'} Mode`}>
              <IconButton
                onClick={toggleColorMode}
                size="small"
                sx={{
                  color: isDark ? '#ffc107' : '#0050cb',
                  backgroundColor: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
                  borderRadius: '20px',
                  px: 1.25,
                  py: 0.25,
                  fontSize: '0.75rem',
                  gap: 0.5,
                  border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)'}`,
                  '&:hover': {
                    backgroundColor: isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)',
                  },
                }}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
                  {isDark ? 'light_mode' : 'dark_mode'}
                </span>
                <Typography variant="caption" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                  {isDark ? 'Light' : 'Dark'}
                </Typography>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TopUtilityBar;
